import { BaseService, Service } from "/@/cool";
@Service("externalPhotos")
class ExternalPhotos extends BaseService {
	constructor() {
		super();
		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}
		this.permission["createPidForExternalPhotos"] = prefix + "createPidForExternalPhotos";
		this.permission["uploadForExternalPhotos"] = prefix + "uploadForExternalPhotos";
	}

	createPidForExternalPhotos(params: any) {
		return this.request({
			url: "/createPidForExternalPhotos",
			method: "POST",
			data: {
				...params
			}
		});
	}

	uploadForExternalPhotos(params: any) {
		return this.request({
			url: "/uploadForExternalPhotos",
			method: "POST",
			data: {
				...params
			}
		});
	}
}
export default ExternalPhotos;
